import HttpFactory from '@/mixins/http.factory';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
	name:'authenticate_outh2',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			isFormValidated:false,
            disableValidateBtn: true,
            data: null,
            client_id: null,
            redirect_uri: null,
			auth:{}
		}
    },
    computed:{
		...mapState('zdDevops',['appData'])
	},
    created() {
        let _self=this;
		_self.init();
	},
    methods: {
        init(){
            let _self = this;
            _self.client_id = _self.$route.params.client_id;
            _self.redirect_uri = _self.$route.query.redirect_uri;
            _self.loading = true;

			modalClient = ZAFClient.init();
			parentClient=null;
            modalClient.on('send_data_to_modal', async (data) => {
              	if (data.ticket.id == _self.$route.params.zdTicketId) {
					          parentClient = modalClient.instance(data.parentClientGuid)
                    _self.zendeskInfo = data;
              		//_self.devOpsTenant = _self.zendeskInfo.userInfo.allowMultiTenant ? _self.zendeskInfo.userInfo.defaultTenant : null;
                    await _self.init_auth();
				}
			});
		},
		async init_auth(){
			let _self=this;
            _self.auth.userId=_self.zendeskInfo.userInfo?_self.zendeskInfo.userInfo.id:null;
            _self.auth.hdLoginUrl=_self.zendeskInfo.credentials.hdLoginUrl;
            _self.auth.hdEmail=_self.zendeskInfo.user.email;
            if(_self.$route.params.devOpsUrl){
                _self.auth.devOpsUrl = decodeURIComponent(_self.$route.params.devOpsUrl);

                // let userId = _self.$route.params.userId ? parseInt(_self.$route.params.userId) : null;
                // userId = isNaN(parseInt(userId)) == true ? null : parseInt(userId);

                _self.auth.userId=_self.$route.params.userId;
            }


            if (_self.client_id) {
                let authData = {
                    appId: _self.$route.params.appId,
                    installationId: _self.$route.params.installationId,
                    //hdTicketId: _self.$route.params.zdTicketId,
                    hdTicketId:_self.zendeskInfo.ticket.id,
                    hdLoginUrl: _self.auth.hdLoginUrl,
                    hdEmail: _self.auth.hdEmail,
                    devOpsUrl: _self.auth.devOpsUrl,
                    userId: _self.$route.params.userId,
                    credentials: _self.zendeskInfo.credentials,
                    user: _self.zendeskInfo.user,
                    //userId: _self.$route.query.userId?_self.$route.query.userId:null,
                };
                if (!authData.userId && authData.devOpsUrl) {
                    authData.userId = _self.auth.userId;
                    authData.userId = isNaN(parseInt(authData.userId)) == true ? null : parseInt(authData.userId);
                }
                const stateStr = `${authData.appId}_${authData.installationId}`;
                const authUrl =
                    `https://${_self.zendeskInfo.ticket.brand.subdomain}.zendesk.com/oauth/authorizations/new?response_type=code&client_id=${_self.client_id}&redirect_uri=${_self.redirect_uri}&scope=read write&state=${stateStr}`;


                //console.log('auth data on outh2', JSON.stringify(authData));
                sessionStorage[`zd_app_Auth_usr_${stateStr}`] = JSON.stringify(authData);

                //document.location.href = authUrl;
                //window.top.location.href = authUrl;
                //client.invoke('routeTo', authUrl);
                //client.invoke('navigateTo', {  target: 'new',url: authUrl});
                setTimeout(function () { window.open(authUrl, '_blank'); }, 1000);



            } else {
                _self.loading = false;
            }
        },
        async getAppData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			try{

				_self.auth.hdLoginUrl=_self.zendeskInfo.credentials.hdLoginUrl;
				_self.auth.hdEmail = _self.zendeskInfo.user.email;

				await this.$store.dispatch('zdDevops/getAppData',{auth:_self.zendeskInfo.credentials});
				_self.data=_self.appData;
			}
			catch(ex){
				_self.commonErrorMsgDisp(ex);
			}
			_self.fn().showLoader(false);
			_self.setAppHeight();

		},
		//auth only
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }

            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            && _self.auth.devOpsUrl && _self.auth.devOpsToken) {
                return true;
            }
            return;
            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('zendesk Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('zendesk Url is invalid.');
            }
            if (!_self.auth.hdToken) {
                _self.userMsg.list.push('zendesk Token is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('zendesk Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('zendesk Email is  invalid.');
			}
            if (!_self.auth.devOpsUrl) {
                _self.userMsg.list.push('Azure DevOps Url is  required.');
            }else if(!_self.validUrl(_self.auth.devOpsUrl)){
                _self.userMsg.list.push('Azure DevOps Url is invalid.');
            }
            if (!_self.auth.devOpsToken) {
                _self.userMsg.list.push('Azure DevOps Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },

        authenticate(e,cb){
            let _self=this;
            //if(!_self.checkForm(e)) return;
            _self.loading=true;
			_self.auth.appId=_self.zendeskInfo.credentials.appId;
			_self.auth.installationId=_self.zendeskInfo.credentials.installationId;
            _self.auth.user=_self.zendeskInfo.user;
            _self.auth.isDevOpsAuthOnly = true;
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate_outh2',//because we just need to validate the devops credentials only here.
				url:'authenticate_outh2', //because we just need to validate the devops credentials only here.
                headers: {'Content-Type': 'application/json'}
            };
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('App validated successfully.');
                    //_self.init();
					_self.sendDataToParent(response.data);
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },

        //begins user level authentication via OAuth2
        getAccessTokenFromCodeFn: function (data) {
			_self.getAccessTokenFromCode(data, function (response) {
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Authorization done Successfully`]}
				}else{
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Authorization failed. Please try again later. If the issue persists please contact at support@devopsintegration.io`]}
				}
				_self.userMsg=userMsg;
			},function(error){
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		getAccessTokenFromCode:function(data,successCb,errorCb){
            var _self=this;

            var url = `getAccessTokenFromCode`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
		},
        //ends user level authentication via OAuth2
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
		//auth ends
        closeDialog(data) {
            let _self= this;
			_self.fn().close_zendesk_modal(data);
		},
        sendDataToParent(data) {
            let _self = this;
            _self.closeDialog(data);
		},
	}
}

